//#region IMPORT
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
/** Components */
import 'dayjs/locale/ko';
import useDelete from '../../../../hooks/useDeleteN';
import { useSearch1, useSearch2, useSearch3, useSearch4, useDelete1, useSave1, useSave2, useSave3 } from './HAZ_BASIC_01_QUERY';
import HAZ_BASIC_01 from './HAZ_BASIC_01';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import { useSave } from '../../../../hooks/useSaveN';
import { HAZ_BASIC_01_Schema } from './HAZ_BASIC_01_Schema';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
import {
  closeLoading as closeLoadingAction,
  showLoading as showLoadingAction,
} from '../../../../Reducer/LoadingReducer';
import { setFileFields } from '../../../../Reducer/FileFieldReducer';
import useFileUpload from '../../../../hooks/useFileUpload';
import dayjs from 'dayjs';
import ExcelJS from 'exceljs';
import { showLoading, closeLoading } from '../../../../Reducer/LoadingReducer';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'HazardousMachines';
//#endregion

function HAZ_BASIC_01F(props) {
  //#region 변수
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const { previewUrl, previewFileName } = useSelector((state) => state.fileField); // 미리보기 상태관리
  const searchInfo = useSelector((state) => state.SearchInfo);
  const gridRef1 = useRef(); //유해위험기계기구 그리드

  const [rowData1, setRowData1] = useState([]); //그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]);
  const [changedRowData1, setChangedRowData1] = useState([]);
  const [deletedRows, setDeletedRowData1] = useState([]);
  const selectedRowNosRef1 = useRef(new Set());
  const lastCheckedIndexRef1 = useRef(null);
  const currentRowIndexRef1 = useRef(null);

  // 파일 업로드 관련 상태
  const [fileModalToggle, setFileModalToggle] = useState(false);
  const fileInputRef = useRef(null); // 엑셀 업로드용 파일 input

  // 토글 및 탭 관련 상태
  const [showTable, setShowTable] = useState(true);
  const [tabValue, setTabValue] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [items, setItems] = useState([]);
  //#endregion

  //#region 커스텀훅
  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const { handleCoChange, handleCustChange, validateSelection } =
    useCompanyCustDep({ requireCompany: true, requireCust: true });

  // 파일 업로드용 useFileUpload
  const {
    SaveLogicPreview,
    SaveLogicFile,
    DeleteLogicFile
  } = useFileUpload({
    oldFilePathField: 'machineImageFilePath',
    newFileNameField: 'machineImageSaveName',
    getTargetPath: () => `HazardousMachines/${searchInfo.custCd}/HAZ_BASIC_01`,
  });

  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.CHAEBUN,
  });
  //#endregion

  //#region useEffect
  useEffect(() => {
    if (props.filterClick1) {
      gridRef1.current.api &&
        gridRef1.current.api.setQuickFilter(searchInfo.searchText || '');
      props.setFilterClick1(false);
    }
    if (props.saveClick1) {
      Save1();
      props.setSaveClick1(false);
    }
    if (props.printClick1) {
      if (!validateSelection()) {
        props.setPrintClick1(false);
        return;
      }
      PrintLogic1();
      props.setPrintClick1(false);
    }
  }, [props.filterClick1, props.saveClick1, props.printClick1]);

  useEffect(() => {
    if (!props.searchClick1) return;
    ResetLogic();

    if (!searchInfo.custCd) {
      props.setSearchClick1(false);
      return;
    }

    if (!validateSelection()) {
      props.setSearchClick1(false);
      return;
    }

    SearchLogic1();
    props.setSearchClick1(false);
  }, [props.searchClick1]);
  //#endregion

  //#region 쿼리
  // 조회
  // useSearch1 - 유해위험기계기구 기본정보 목록 조회 (사업장코드 기준)
  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });
  // useSearch2 - 토글 상태 조회
  const { runAsync: Search2Async } = useSearch2();
  // useSearch3 - 탭 데이터 조회
  const { runAsync: Search3Async } = useSearch3();
  // useSearch4 - 캘린더 정보 조회
  const { runAsync: Search4Async } = useSearch4();

  // 삭제
  // useDelete1 - 유해위험기계기구 기본정보 삭제 (채번, 알람ID 기준)
  const delete1 = useDelete1();
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRows,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 저장
  // useSave1 - 유해위험기계기구 기본정보 저장 (기계명, 종류, 설치장소, 검사일자 등 모든 기본정보)
  const { runAsync: Save1Async } = useSave1();
  // useSave2 - 알람 생성/삭제 처리
  const { runAsync: Save2Async } = useSave2();
  // useSave3 - 토글 상태 저장
  const { runAsync: Save3Async } = useSave3();
  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '기계·기구명, 알람여부',
    schema: HAZ_BASIC_01_Schema,
    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRows,
    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: async (rows) => {
      // 1. 알람 처리 (Save2Async)
      const rowsWithAlarm = await Promise.all(
        rows.map(async (item) => {
          let alarmId = 0;
          try {
            // 캘린더 정보 조회
            const calendarData = await Search4Async();
            if (calendarData && calendarData.length > 0) {
              // mainCalendar = 'Y'인 것의 calId 찾기
              const mainCalendar = calendarData.find((cal) => cal.mainCalendar === 'Y');
              const calId = mainCalendar?.calId || null;
              if (calId) {
                // 알람 생성/삭제 처리
                const alarmResult = await Save2Async([{ ...item, calId }]);
                const alarmData = alarmResult?.data || [];
                if (alarmData && alarmData.length > 0) {
                  alarmId = alarmData[0]?.alarmId || null;
                }
              }
            }
          } catch (error) {
            console.error('알람 처리 중 오류:', error);
            // 알람 처리 실패해도 저장은 진행
          }
          return { ...item, alarmId };
        })
      );
      // 2. 저장 (Save1Async)
      return Save1Async(rowsWithAlarm);
    },
    fileDelete: async (deletedRows) => {
      // 삭제된 행들에 대해 파일 삭제 처리
      for (const item of deletedRows) {
        if (item.machineImageFilePath) {
          await DeleteLogicFile(item.machineImageFilePath);
        }
      }
    },
    fileSave: async (changedRows) => {
      // 저장된 행들에 대해 파일 저장 처리
      for (const item of changedRows) {
        // 파일이 삭제된 경우 (파일명이 빈 문자열이고 기존 파일 경로가 있는 경우)
        if (!item.machineImageFileName && item.machineImageFilePath) {
          // 저장소에서 기존 파일 삭제
          await DeleteLogicFile(item.machineImageFilePath);
        }
        // 새 파일이 업로드된 경우
        else if (item.previewFilePath) {
          await SaveLogicFile(item, searchInfo.custCd);
        }
      }
    },
    onSuccessRefresh: () => SearchLogic1(),
    partialRefresh: async ({ saveResult, changedRows }) => {
      await handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: SearchLogic1,
      });
    },
  });

  const ResetLogic = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
    gridRef1?.current?.api?.deselectAll();
  };

  const SearchLogic1 = async () => {
    ResetLogic();
    if (!validateSelection()) return;

    // 토글 상태 조회
    try {
      const toggleResult = await Search2Async();
      if (toggleResult && toggleResult.length > 0) {
        const toggleStatus = toggleResult[0]?.toggleStatus === 'Y' ? true : false;
        setShowTable(toggleStatus);
      }
    } catch (error) {
      console.error('토글 상태 조회 오류:', error);
    }

    // 탭 데이터 조회
    try {
      const tabResult = await Search3Async();
      if (tabResult && tabResult.length > 0) {
        const grouped = tabResult.reduce((acc, cur) => {
          if (!acc[cur.rangeType]) acc[cur.rangeType] = [];
          acc[cur.rangeType].push({
            value: cur.seq,
            label: cur.machineType,
            description: cur.specScope,
          });
          return acc;
        }, {});

        const tabsData = Object.keys(grouped).map((rangeType, idx) => ({
          rangeType,
          items: grouped[rangeType],
        }));

        setItems(tabsData);
      } else {
        setItems([]);
      }
    } catch (error) {
      console.error('탭 데이터 조회 오류:', error);
      setItems([]);
    }

    // 기본 데이터 조회
    await Search1();
  };

  const SaveLogic0 = async (value1) => {
    const toggleStatus = value1 ? 'Y' : 'N';
    try {
      await Save3Async([{ toggleStatus }]);
      setShowTable(value1);
    } catch (error) {
      console.error('토글 상태 저장 오류:', error);
    }
  };
  //#endregion

  //#region 나머지 함수
  const DownloadLogic1 = async () => {
    try {
      let filePath = '';
      let fileName = previewFileName || 'downloaded_file';

      if (previewUrl) {
        if (previewUrl.startsWith('data:')) {
          const a = document.createElement('a');
          a.href = previewUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          dispatch(showSnackbar({ message: `"${fileName}" 다운로드 완료`, type: 'success' }));
          return;
        }
        filePath = previewUrl.includes(Global.file.useUrl + 'files/')
          ? decodeURIComponent(previewUrl.replace(Global.file.useUrl + 'files/', ''))
          : previewUrl;
      } else {
        const rowData = selectedRowData1?.[0];
        if (!rowData) {
          dispatch(showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' }));
          return;
        }
        filePath = rowData.previewFilePath || rowData.machineImageFilePath || '';
        fileName = rowData.machineImageFileName || fileName;
        if (!filePath) {
          dispatch(showSnackbar({ message: '파일이 존재하지 않습니다.', type: 'warning' }));
          return;
        }
      }

      const finalFileName = fileName === 'downloaded_file'
        ? decodeURIComponent(filePath.split('/').pop() || fileName)
        : fileName;

      const result = await Commons.Axios(
        'fileDown',
        Global.file.useUrl + Global.urls.Execute.UrlFileDownload,
        { FileName: finalFileName, Url: Commons.EncodeUrl(filePath) }
      );

      if (!result?.data || !result?.headers?.['content-type']) {
        dispatch(showSnackbar({ message: `"${finalFileName}" 다운로드 응답이 비정상입니다.`, type: 'error' }));
        return;
      }

      const blob = new Blob([result.data], { type: result.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = finalFileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      dispatch(showSnackbar({ message: `"${finalFileName}" 다운로드 완료`, type: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: error.message, type: 'error' }));
    }
  };

  // 인쇄 함수
  const PrintLogic1 = useCallback(async () => {
    // 데이터 확인
    const currentRowData = rowData1.filter((row) => !row.deleteYn);
    if (currentRowData.length === 0) {
      dispatch(
        showSnackbar({
          message: '인쇄할 데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    dispatch(showLoadingAction());

    try {
      const currentYear = dayjs().year();
      const headerData = {
        CURRENT_YEAR: currentYear,
      };

      const tableData = await Promise.all(
        currentRowData.map(async (item) => {
          let machineImageBase64 = null;

          if (item.machineImageFilePath) {
            try {
              const fixedPath = Commons.EncodeUrl(item.machineImageFilePath);
              const imageUrl = Global.file.useUrl + 'files/' + fixedPath;

              const response = await fetch(imageUrl);
              if (response.ok) {
                const blob = await response.blob();
                const base64Image = await new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onloadend = () => resolve(reader.result);
                  reader.onerror = reject;
                  reader.readAsDataURL(blob);
                });

                if (base64Image && base64Image.startsWith('data:')) {
                  machineImageBase64 = base64Image.replace(
                    /^data:image\/[a-z]+;base64,/,
                    ''
                  );
                }
              }
            } catch (error) {
              machineImageBase64 = null;
            }
          }
          return {
            NO: item.no || '',
            INITIAL_REGULAR: item.initialRegular || '',
            MACHINE_NAME: item.machineName || '',
            TYPE: item.type || '',
            INSTALL_LOCATION: item.installLocation || '',
            DEPARTMENT: item.department || '',
            PERSON_IN_CHARGE: item.personInCharge || '',
            MAIN_STRUCTURE_SPEC: item.mainStructureSpec || '',
            MANUFACTURER: item.manufacturer || '',
            SERIAL_NO: item.serialNo || '',
            INITIAL_INSTALL_DATE: item.initialInstallDate
              ? dayjs(item.initialInstallDate).format('YYYY-MM-DD')
              : '',
            PASS_NO: item.passNo || '',
            INSPECTION_AGENCY: item.inspectionAgency || '',
            INSPECTOR: item.inspector || '',
            REMARK: item.remark || '',
            MACHINE_IMAGE: machineImageBase64 || null,
            INSPECTION_DATE: item.inspectionDate
              ? dayjs(item.inspectionDate).format('YYYY-MM-DD')
              : '',
            VALIDITY_DATE: item.validityDate
              ? dayjs(item.validityDate).format('YYYY-MM-DD')
              : '',
            INSPECTION_CYCLE: item.inspectionCycle || '',
          };
        })
      );

      const printData = {
        FileName: 'HAZ_BASIC_01',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      dispatch(closeLoadingAction());
    }
  }, [rowData1, dispatch]);

  const PopupClickEvent1 = async (rowData) => {
    const fileName = rowData.machineImageFileName || '';
    const filePath = rowData.machineImageFilePath || '';
    const previewPath = rowData.previewFilePath || '';

    let previewUrl = '';
    if (previewPath) {
      const fixedPath = Commons.EncodeUrl(previewPath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    } else if (filePath) {
      const fixedPath = Commons.EncodeUrl(filePath);
      previewUrl = fixedPath ? Global.file.useUrl + 'files/' + fixedPath : '';
    }

    dispatch(setFileFields({
      previewFileName: fileName || '파일 선택',
      previewUrl,
    }));

    setTimeout(() => setFileModalToggle(true), 100);
  };

  const NewYnErrorMsg = () => {
    dispatch(showSnackbar({ message: '데이터 입력중입니다. 저장 후 시도하세요.', type: 'warning' }));
  };

  const handleRowSelection1 = (rowData, rowIndex) => {
    currentRowIndexRef1.current = rowIndex;
    setSelectedRowData1([rowData]);
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleItemClick = (item) => {
    if (selectedItem?.value === item.value) {
      setSelectedItem(null);
    } else {
      setSelectedItem(item);
    }
  };

  const getCheckItemsByTab = (tabIndex) => {
    if (!items || items.length === 0) return [];
    return items[tabIndex]?.items ?? [];
  };

  // 엑셀 업로드
  const ExcelUpload1 = async (file) => {
    try {
      dispatch(showLoadingAction());

      const arrayBuffer = await file.arrayBuffer();
      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '엑셀 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }

      // 8행부터 데이터 읽기
      const startRow = 6;
      const columnKeys = [
        'initialRegular',
        'machineName',
        'type',
        'installLocation',
        'department',
        'personInCharge',
        'mainStructureSpec',
        'manufacturer',
        'serialNo',
        'initialInstallDate',
        'inspectionDate',
        'validityDate',
        'passNo',
        'inspectionAgency',
        'inspector',
        'alarmYn',
        'remark',
      ];

      const uploadedData = [];
      let currentRow = startRow;
      let hasData = true;

      while (hasData) {
        const row = worksheet.getRow(currentRow);
        const rowData = {};

        // 첫 번째 컬럼(최초/정기)이 비어있으면 데이터가 없는 것으로 간주
        const firstCellValue = row.getCell(1).value;
        if (!firstCellValue || firstCellValue.toString().trim() === '') {
          hasData = false;
          break;
        }

        columnKeys.forEach((key, index) => {
          const cell = row.getCell(index + 1);
          let value = cell.value;

          // 값이 없으면 빈 문자열 또는 null
          if (value === null || value === undefined) {
            value = '';
          } else {
            // 날짜 필드는 ISO 형식으로 변환
            if (key.includes('Date')) {
              if (value instanceof Date) {
                value = value.toISOString();
              } else if (typeof value === 'number') {
                // Excel 날짜 번호를 Date로 변환
                const excelDate = new Date((value - 25569) * 86400 * 1000);
                value = excelDate.toISOString();
              } else {
                value = value.toString().trim();
              }
            } else {
              // 객체인 경우 문자열로 변환
              if (typeof value === 'object' && value !== null) {
                value = Array.isArray(value.richText) && value.richText.length > 0
                  ? value.richText.map(item => item?.text || '').join('')
                  : value.toString().trim();
              } else {
                value = value.toString().trim();
              }
            }
          }

          rowData[key] = value;
        });

        // 최소한 기계명이 있으면 추가
        if (rowData.machineName) {
          rowData.newYn = 'Y';
          rowData.no = `new_${Date.now()}_${currentRow}`;
          uploadedData.push(rowData);
        }

        currentRow++;
        // 최대 1000행까지만 읽기 (무한 루프 방지)
        if (currentRow > startRow + 1000) {
          break;
        }
      }

      if (uploadedData.length === 0) {
        dispatch(
          showSnackbar({
            message: '읽을 수 있는 데이터가 없습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return;
      }

      // 키값 생성 함수 (machineName 조합)
      const makeKeyString = (item) => {
        const machineName = item.machineName !== null && item.machineName !== undefined
          ? String(item.machineName).trim()
          : '';
        return machineName;
      };

      // 기존 데이터를 Map으로 변환
      const existingDataMap = new Map();
      rowData1.forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (key) {
            existingDataMap.set(key, row);
          }
        }
      });

      // 엑셀 데이터의 키 Set 생성
      const excelKeySet = new Set();
      uploadedData.forEach((row) => {
        const key = makeKeyString(row);
        if (key) {
          excelKeySet.add(key);
        }
      });

      // 데이터 변경 여부 확인 함수
      const hasChanges = (existingRow, excelRow) => {
        const fieldsToCompare = columnKeys.filter(key => key !== 'machineName');
        for (const field of fieldsToCompare) {
          let existingValue = existingRow[field];
          let excelValue = excelRow[field];

          // 날짜 필드는 날짜 부분만 비교 (ISO 형식에서 날짜 부분만 추출)
          if (field.includes('Date')) {
            if (existingValue) {
              const existingDate = dayjs(existingValue);
              if (existingDate.isValid()) {
                existingValue = existingDate.format('YYYY-MM-DD'); // YYYY-MM-DD 형식
              } else {
                existingValue = String(existingValue || '').trim();
              }
            } else {
              existingValue = '';
            }

            if (excelValue) {
              const excelDate = dayjs(excelValue);
              if (excelDate.isValid()) {
                excelValue = excelDate.format('YYYY-MM-DD'); // YYYY-MM-DD 형식
              } else {
                excelValue = String(excelValue || '').trim();
              }
            } else {
              excelValue = '';
            }
          } else {
            // 날짜가 아닌 필드는 문자열로 변환
            existingValue = existingValue !== null && existingValue !== undefined
              ? String(existingValue).trim()
              : '';
            excelValue = excelValue !== null && excelValue !== undefined
              ? String(excelValue).trim()
              : '';
          }

          if (existingValue !== excelValue) {
            return true;
          }
        }
        return false;
      };

      const newRows = [];
      const updatedRows = [];
      const updatedKeys = new Set();

      // 엑셀 데이터 처리
      for (const excelRow of uploadedData) {
        // 최초/정기에 따라 검사주기 자동 세팅
        // - 최초: 3년
        // - 정기: 2년
        // (엑셀 업로드 컬럼에서 inspectionCycle을 제외했더라도 저장 시점에 값이 맞도록 보정)
        const initialRegular = String(excelRow.initialRegular || '').trim();
        excelRow.inspectionCycle =
          initialRegular === '최초' ? '3년' : initialRegular === '정기' ? '2년' : '';

        const key = makeKeyString(excelRow);

        if (!key) {
          continue;
        }

        if (existingDataMap.has(key)) {
          const existingRow = existingDataMap.get(key);

          if (hasChanges(existingRow, excelRow)) {
            const updatedRow = {
              ...existingRow,
              ...excelRow,
              newYn: existingRow.newYn || 'N',
              editYn: 'Y',
              no: existingRow.no,
              chaebun: existingRow.chaebun || '',
            };
            updatedRows.push(updatedRow);
            updatedKeys.add(key);
          }
        } else {
          newRows.push({
            ...excelRow,
            newYn: 'Y',
            no: `new_${Date.now()}_${Math.random()}`,
          });
        }
      }

      // 기존 데이터 중 엑셀에 없는 데이터는 삭제 대상으로 표시
      const rowsToDelete = [];
      rowData1.forEach((row) => {
        if (!row.deleteYn) {
          const key = makeKeyString(row);
          if (key && !excelKeySet.has(key) && row.deleteYn !== 'Y') {
            rowsToDelete.push({
              ...row,
              deleteYn: 'Y',
            });
          }
        }
      });

      // 기존 데이터 업데이트
      const updatedRowData = rowData1.map((row) => {
        if (row.deleteYn) return row;
        const key = makeKeyString(row);
        if (key && updatedKeys.has(key)) {
          const updatedRow = updatedRows.find((ur) => makeKeyString(ur) === key);
          if (updatedRow) return updatedRow;
        }
        if (rowsToDelete.some((rd) => rd.no === row.no)) {
          return { ...row, deleteYn: 'Y' };
        }
        return row;
      });

      // 업데이트된 행과 신규 행을 합쳐서 그리드에 설정
      const finalRowData = [...updatedRowData, ...newRows];
      gridRef1.current.api.setRowData(finalRowData);

      // 변경된 데이터 설정
      const changedData = [...updatedRows, ...newRows];
      setChangedRowData1(changedData);

      // 삭제된 데이터 설정
      if (rowsToDelete.length > 0) {
        setDeletedRowData1((prev) => {
          const existingDeleted = prev || [];
          const newDeleted = rowsToDelete.filter(
            (rd) => !existingDeleted.some((ed) => ed.no === rd.no)
          );
          return [...existingDeleted, ...newDeleted];
        });
      }

      dispatch(
        showSnackbar({
          message: '엑셀 업로드가 완료되었습니다.',
          type: 'success',
        })
      );
    } catch (error) {
      console.error('Excel upload error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 업로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoadingAction());
    }
  };

  // 엑셀 다운로드
  const ExcelDownload1 = async () => {
    try {
      dispatch(showLoadingAction());

      const workbook = new ExcelJS.Workbook();
      const templateUrl = getTemplatePath();

      const response = await fetch(templateUrl);
      const arrayBuffer = await response.arrayBuffer();
      await workbook.xlsx.load(arrayBuffer);

      const worksheet = workbook.worksheets[0];
      if (!worksheet) {
        dispatch(
          showSnackbar({
            message: '템플릿 시트를 불러오지 못했습니다.',
            type: 'warning',
          })
        );
        dispatch(closeLoadingAction());
        return false;
      }

      // 합계 행 제외한 데이터만 사용
      const detailData = rowData1.filter((r) => !r.deleteYn);

      // 데이터 삽입
      const startRow = 6;
      const columnKeys = [
        'initialRegular',
        'machineName',
        'type',
        'installLocation',
        'department',
        'personInCharge',
        'mainStructureSpec',
        'manufacturer',
        'serialNo',
        'initialInstallDate',
        'inspectionDate',
        'validityDate',
        'passNo',
        'inspectionAgency',
        'inspector',
        'alarmYn',
        'remark',
      ];

      detailData.forEach((item, index) => {
        const row = worksheet.getRow(startRow + index);
        columnKeys.forEach((key, i) => {
          const cell = row.getCell(i + 1);

          let value = item[key];

          // 날짜 필드는 YYYY-MM-DD 문자열로 저장 (타임존 영향 없음, 하루 밀림 방지)
          if (key.includes('Date')) {
            if (value) {
              // 날짜 필드는 YYYY-MM-DD 문자열로 변환 (dayjs로 날짜 부분만 사용)
              const date = dayjs(value);
              value = date.isValid() ? date.format('YYYY-MM-DD') : '';
            } else {
              value = '';
            }
            cell.numFmt = '@'; // 텍스트 형식 → 엑셀에서 타임존 변환 없음
          } else {
            value = value || '';
          }

          // 값 설정 및 기존 스타일 유지
          setPreserveStyle(cell, value);

          // 스타일 덮어쓰기
          cell.font = { name: 'Arial', size: 10 };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
            wrapText: false,
          };
          cell.border = {
            top: { style: 'thin', color: { argb: 'FF808080' } },
            left: { style: 'thin', color: { argb: 'FF808080' } },
            bottom: { style: 'thin', color: { argb: 'FF808080' } },
            right: { style: 'thin', color: { argb: 'FF808080' } },
          };
        });
        row.commit();
      });

      // 최초/정기와 검사주기 컬럼에 드롭다운 추가
      // 데이터가 없는 행에도 드롭다운이 적용되도록 충분한 범위 설정 (200행까지)
      const maxDataRow = Math.max(startRow + detailData.length, startRow + 200);
      const endRow = maxDataRow;

      // 최초/정기 컬럼 (A열, 첫 번째 컬럼)
      const initialRegularCol = 'A';
      worksheet.dataValidations.add(`${initialRegularCol}${startRow}:${initialRegularCol}${endRow}`, {
        type: 'list',
        allowBlank: true,
        formulae: ['"최초,정기"'],
        showErrorMessage: true,
        errorStyle: 'error',
        errorTitle: '입력 오류',
        error: '최초 또는 정기만 입력 가능합니다.',
      });

      // 알람여부 컬럼
      // columnKeys 배열에서 alarmYn의 인덱스 확인: 0=initialRegular, ..., 15=alarmYn, 16=remark
      const alarmYnColIndex = columnKeys.indexOf('alarmYn');
      if (alarmYnColIndex !== -1) {
        // Excel 열 번호를 문자로 변환 (1=A, 2=B, ..., 18=R)
        const alarmYnCol = String.fromCharCode(65 + alarmYnColIndex); // 65는 'A'의 ASCII 코드
        worksheet.dataValidations.add(`${alarmYnCol}${startRow}:${alarmYnCol}${endRow}`, {
          type: 'list',
          allowBlank: true,
          formulae: ['"Y,N"'],
          showErrorMessage: true,
          errorStyle: 'error',
          errorTitle: '입력 오류',
          error: 'Y 또는 N만 입력 가능합니다.',
        });
      }

      // 날짜 컬럼들에 YYYY-MM-DD 형식 검증 추가
      const dateFields = ['initialInstallDate', 'inspectionDate', 'validityDate'];
      dateFields.forEach((dateField) => {
        const dateFieldColIndex = columnKeys.indexOf(dateField);
        if (dateFieldColIndex !== -1) {
          const colNumber = dateFieldColIndex + 1;
          const column = worksheet.getColumn(colNumber);

          // 1. 기존 데이터들을 YYYY-MM-DD 문자열로 강제 변환
          worksheet.eachRow((row, rowNumber) => {
            if (rowNumber >= startRow && rowNumber <= endRow) {
              const cell = row.getCell(colNumber);
              if (cell.value instanceof Date) {
                // Date 객체인 경우 변환
                cell.value = cell.value.toISOString().split('T')[0];
              } else if (typeof cell.value === 'number') {
                // 45962 같은 숫자(일련번호)인 경우 ExcelJS의 기능을 빌려 변환 가능하나, 
                // 가급적 데이터를 넣는 시점에 문자열로 넣는 것이 가장 안전합니다.
              }
            }
          });

          // 2. 컬럼 형식을 텍스트로 지정
          column.numFmt = '@';

          // 3. 유효성 검사 추가 (기존 코드와 동일)
          const dateFieldCol = column.letter;
          worksheet.dataValidations.add(`${dateFieldCol}${startRow}:${dateFieldCol}${endRow}`, {
            type: 'custom',
            allowBlank: true,
            formulae: [`OR(${dateFieldCol}${startRow}="", AND(LEN(${dateFieldCol}${startRow})=10, MID(${dateFieldCol}${startRow},5,1)="-", MID(${dateFieldCol}${startRow},8,1)="-"))`],
            showErrorMessage: true,
            errorStyle: 'error',
            errorTitle: '입력 오류',
            error: '날짜는 YYYY-MM-DD 형식으로 입력해주세요. (예: 2025-01-15)',
          });
        }
      });

      // 파일명 만들기
      const dateTimeStr = getCurrentFormattedDateTime('file');
      const methodName = `안전검사_${dateTimeStr}.xlsx`;

      // 다운로드
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = methodName;
      link.click();

      dispatch(closeLoadingAction());
    } catch (error) {
      console.error('Excel download error:', error);
      dispatch(
        showSnackbar({
          message: `엑셀 다운로드 중 오류가 발생했습니다: ${error.message}`,
          type: 'error',
        })
      );
      dispatch(closeLoadingAction());
    }
  };

  // 스타일 유지하며 값만 교체
  function setPreserveStyle(cell, value) {
    if (!cell) return;
    const { font, alignment, border, fill, numFmt } = cell;
    cell.value = value;
    cell.style = { font, alignment, border, fill, numFmt };
  }

  // 템플릿 경로 가져오기
  function getTemplatePath() {
    const base = `${Global.file.useUrl}files/ExcellExportFrom/HazardousMachines/`;
    return base + '안전검사.xlsx';
  }

  // 현재 날짜와 시간을 'YYYY-MM-DD HH:mm:ss' 형식으로 반환하는 함수
  function getCurrentFormattedDateTime(_type) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    if (_type === 'data') {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else if (_type === 'file') {
      return `${year}${month}${day}_${hours}${minutes}${seconds}`;
    } else {
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
  //#endregion

  return (
    <div className="wrap">
      <HAZ_BASIC_01
        gridId1={'grid1'}
        navigate={navigate}
        userInfo={userInfo}
        rowData1={rowData1}
        lanInfo={lanInfo}
        gridRef1={gridRef1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        deletedRowData1={deletedRows}
        selectedRowNosRef1={selectedRowNosRef1}
        lastCheckedIndexRef1={lastCheckedIndexRef1}
        currentRowIndexRef1={currentRowIndexRef1}
        fileModalToggle={fileModalToggle}
        setFileModalToggle={setFileModalToggle}
        showTable={showTable}
        setShowTable={setShowTable}
        tabValue={tabValue}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        items={items}
        searchInfo={searchInfo}
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        validateSelection={validateSelection}
        ResetLogic1={ResetLogic}
        SearchLogic1={SearchLogic1}
        PopupClickEvent1={PopupClickEvent1}
        SaveLogic1={Save1}
        SaveLogic0={SaveLogic0}
        DownloadLogic1={DownloadLogic1}
        NewYnErrorMsg={NewYnErrorMsg}
        handleRowSelection1={handleRowSelection1}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        handleTabChange={handleTabChange}
        getCheckItemsByTab={getCheckItemsByTab}
        handleItemClick={handleItemClick}
        PrintLogic1={PrintLogic1}
        SaveLogicPreview={SaveLogicPreview}
        DeleteLogicFile={DeleteLogicFile}
        fileInputRef={fileInputRef}
        ExcelUpload1={ExcelUpload1}
        ExcelDownload1={ExcelDownload1}
      />
    </div>
  );
}

export default HAZ_BASIC_01F;
